import { OnboardingChecklist } from '../components/OnboardingChecklist'
import { AnnouncementWidget } from '../components/AnnouncementWidget'
import { EmergencyContactsWidget } from '../features/contacts/components/EmergencyContactsWidget'
import { VehicleRemindersWidget } from '../features/vehicles/components/VehicleRemindersWidget'
import { MedicationRefillsWidget } from '../features/medications/components/MedicationRefillsWidget'
import { useAuth } from '../hooks/useAuth'
import { useProfile } from '../hooks/useProfile'

const greet = () => {
  const h = new Date().getHours()
  if (h < 12) return 'Good morning'
  if (h < 17) return 'Good afternoon'
  return 'Good evening'
}

export const HomePage = () => {
  const { household, isLimited } = useAuth()
  const { data: profile } = useProfile()

  const firstName = profile?.display_name?.split(' ')[0]

  return (
    <div className="max-w-2xl mx-auto px-4 py-6 page-enter">
      <h1 className="text-2xl font-bold text-text-primary mb-1">
        {firstName ? `${greet()}, ${firstName}` : household?.name ?? 'Home'}
      </h1>
      {household?.name && firstName && (
        <p className="text-sm text-text-muted mb-6">{household.name}</p>
      )}
      {!firstName && <div className="mb-6" />}

      <OnboardingChecklist />
      <AnnouncementWidget />
      <EmergencyContactsWidget />
      <VehicleRemindersWidget />
      {!isLimited && <MedicationRefillsWidget />}
    </div>
  )
}
